import { MathHelper } from "Utility/MathHelper";
import Point from "Utility/Point";

interface IToPOTOptions {
    fitSide?: "width" | "height" | "none",
    anchor?: Point
}

export class Texture extends PIXI.Texture {
    public static toPOT(texture: PIXI.Texture, options?: IToPOTOptions): Texture {
        const sprite = new PIXI.Sprite(texture);
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const { fitSide = 'none', anchor = Point.Center } = options ?? {};
        const constraints = {
            width: MathHelper.getNextPOT(texture.width),
            height: MathHelper.getNextPOT(texture.height)
        }

        if (fitSide !== "none") {
            const otherSide = fitSide === "width" ? "height" : "width";
            // Set side to full canvas size
            sprite[fitSide] = constraints[fitSide];
            // Get new constraint for other side after scaling to fit main side
            constraints[otherSide] = MathHelper.getNextPOT(sprite[otherSide]);
        }

        // Update canvas size to POT
        canvas.width = constraints.width;
        canvas.height = constraints.height;

        context.drawImage(
            texture.baseTexture.source,
            texture.frame.x,
            texture.frame.y,
            texture.frame.width,
            texture.frame.height,
            (canvas.width - sprite.width) * anchor.x,
            (canvas.height - sprite.height) * anchor.y,
            sprite.width,
            sprite.height
        );

        return Texture.from(canvas);
    }
}
